import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

/** A small "are you sure?" dialog. The parent owns the open/busy state. */
@Component({
  selector: 'app-social-confirm-dialog',
  templateUrl: './social-confirm-dialog.component.html',
  styleUrls: ['./social-confirm-dialog.component.scss'],
  standalone: false,
})
export class SocialConfirmDialogComponent implements OnChanges {
  @Input() open = false;
  @Input() title = 'Are you sure?';
  @Input() message = '';
  @Input() confirmLabel = 'Delete';
  /** Shown on the confirm button while busy, in place of confirmLabel. */
  @Input() busyLabel = 'Deleting…';
  @Input() busy = false;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  @ViewChild('cancelButton') cancelButton?: ElementRef<HTMLButtonElement>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open'] && this.open) {
      // Start on the safe choice, so Enter can't delete by accident.
      setTimeout(() => this.cancelButton?.nativeElement.focus());
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open && !this.busy) {
      this.cancel.emit();
    }
  }
}
